import Splide from '@splidejs/splide';

export default class relatedArticles {
	constructor(wrapper) {
		this.mainslides 		= wrapper;
		this.customNextButtons 	= document.querySelectorAll('.splide--next');
		this.customPrevButtons 	= document.querySelectorAll('.splide--prev');

		if(this.mainslides) {
			this.mainSlider = new Splide(this.mainslides, 
			{
				type		: 'loop',
				pagination 	: false,
				arrows     	: false,
				drag		: true,
				autoWidth	: true,
				autoHeight	: true,
				perPage		: 1,
				pauseOnHover : true,
				gap			: 32,
				padding: '160px',
				breakpoints: {
					1239: {
						padding: '100px',
					},
					1023: {
						padding: '24px',
						gap: '24px',
					},
					640: {
						gap: '24px',
					},
				}
			})
		}
		this.mainSlider.mount()

		this.customNextButtons && this.customNextButtons.forEach((customNextButton) => {
			customNextButton.addEventListener('click', e => {
				this.mainSlider.go('+1')
			})
		})

		this.customPrevButtons && this.customPrevButtons.forEach((customPrevButton) => {
			customPrevButton.addEventListener('click', e => {
				this.mainSlider.go('-1')
			})
		})
	}

	init() {

		

	}
}
